import React, { Component } from 'react';
import RootRouter from './router/router';
class App extends Component {
  componentDidMount(){
    // var header =  document.getElementById('header');
    // var logo =  document.getElementById('logo');
    // var logoBlue =  document.getElementById('logo-blue');
    // var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    // if(scrollTop>200){
    //   header.classList.add("header-bg-white");
    //   logoBlue.style.display='block';
    //   logo.style.display='none';
    // }else{
    //   header.classList.remove("header-bg-white");
    //   logoBlue.style.display='none';
    //   logo.style.display='block';
    // }
    // window.onscroll =function(){
    //   scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    //   if(scrollTop>200){
    //     header.classList.add("header-bg-white");
    //     logoBlue.style.display='block';
    //     logo.style.display='none';
    //   }else{
    //     header.classList.remove("header-bg-white");
    //     logoBlue.style.display='none';
    //     logo.style.display='block';
    //   }
    // }

  }


  render() {
    return (
        <RootRouter />
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js